export const LOGIN_API = "api/Login/ClientLogin";
export const CREATE_CLIENT_LOGIN = "api/Login/CreateClientLogin";
export const SAVE_CLIENT_LOGIN = "api/Login/SaveClientDetails";
export const CLIENT_OVERVIEW_API = "api/Client/GetClientOverview";
export const SITE_MEASURES_API = "api/Site/GetSiteMeasures";
export const DOWNLOAD_SUBMITTED_WORKSHEET = "api/Site/DownloadSubmittedWorksheet";
export const GET_CLIENT_ACCOUNTS = "api/Client/GetClientAccounts";

export const SERVICE_LOCATION = "https://eeg-clientportalapi.azurewebsites.net/";   //https://localhost:7107/   //https://eeg-clientportalapi.azurewebsites.net/